import * as React from "react";
import {cx}       from "emotion";

import "./new-template-options.scss";

import {ComponentLink,
        Link,
        makeChain}     from "@Common/react/cst2";

import {TemplateUploadButton} from "../components/template-upload-button";


export const NewTemplateOptions = ({
    onUploadComplete,
    onUploadError,
}:{
    onUploadComplete  : (idmlInfo:any) => void,
    onUploadError     : (error:string) => void,
}) => (

    makeChain<JSX.Element>()

    // render view
    .then(({}) => (
        <div className="new-template-options-6rd">
            <div className="box">
                <h1>Start with a<br/> Blank Canvas</h1>
                <p>Select from our basic layouts and build your design from scratch.</p>
                <button
                    onClick={() => window.location.hash = "#new-template-product"}
                    xd-qa-type="button" xd-qa-name="New Template Select Product"
                >Select Product</button>
            </div>
            <div className="box">
                <h1>Upload Your Own<br/> Template</h1>
                <p>Select an IDML template file for a fully custom layout.</p>
                <TemplateUploadButton
                    onUploadComplete={onUploadComplete}
                    onUploadError={onUploadError}
                />
            </div>
        </div>
    ))

    .run()

);
